// extracted by extract-css-chunks-webpack-plugin
module.exports = {"relative":"relative_2eO4O","banner":"banner_2o6pD relative_2eO4O","fallback":"fallback_2Ay6E","link":"link_2PLu2"};